export default "__VITE_ASSET__B$6QmFz1__"